import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Pencil Off"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-pencil-off',
    templateUrl: './icon-pencil-off.component.html',
    styleUrls: ['./icon-pencil-off.component.scss'],
    standalone: false
})
export class IconPencilOffComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
